import httpService from '@/services/httpService'
// eslint-disable-next-line no-unused-vars
import Overview from '../../../features/reports/rank-zone/overview/Overview'

export const types = {
  ADD_OVERVIEW_DATA: 'rank-zone/ADD_OVERVIEW_DATA'
}
const emptyOverviewData = {
  competitors: [],
  rank_zones: [],
  sections: [],
  statuses: [],
  rank_zone_snapshots: [],
  breakdown: [],
  keywords: [],
  keywords_total: {}
}
const state = {
  overviewData: emptyOverviewData
}

const mutations = {
  [types.ADD_OVERVIEW_DATA]: function (state, overviewData) {
    state.overviewData = { ...overviewData }
  }
}

const actions = {
  getOverviewData: async function ({ commit, dispatch }, clientId) {
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    const selectedMsv = msv[clientId] || 1
    const overviewData = await httpService.get(`/reports/rankzone-report/overview/${clientId}`, { params: { msv: selectedMsv } })
    if (!overviewData || !overviewData.data) {
      return
    }
    commit(types.ADD_OVERVIEW_DATA, overviewData.data)
    return overviewData.data
  },
  resetOverviewData: function ({ commit }) {
    commit(types.ADD_OVERVIEW_DATA, emptyOverviewData)
  }
}

/**
 * Store keep data for {@link Overview} component
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
